import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { ParamData } from "../../../types/Param";
import { getDailyAuditCount } from "../../../api/LogReport";

interface Props {
  data: ParamData; // contains startingFrom, endingOn, entityName
}

const DailyAudit: React.FC<Props> = ({ data }) => {
  const [created, setCreated] = useState(0);
  const [updated, setUpdated] = useState(0);
  const [deleted, setDeleted] = useState(0);

  useEffect(() => {
    const loadData = async () => {
      try {
        const resp = await getDailyAuditCount(data);

        setCreated(Number(resp.created));
        setUpdated(Number(resp.updated));
        setDeleted(Number(resp.deleted));
      } catch (ex) {
        console.error(ex);
      }
    };

    loadData();
  }, [data.entity, data.startingFrom, data.endingOn, data.entity]);

  const series = [created, updated, deleted];

  const options: ApexOptions = {
    labels: ["Created", "Updated", "Deleted"],
    legend: {
      position: "bottom",
    },
    dataLabels: {
      enabled: true,
      formatter: (val: number) => `${val.toFixed(1)}%`,
    },
    colors: ["#4caf50", "#ff9800", "#f44336"], // green, orange, red
    chart: {
      type: "pie",
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: { width: "100%" },
          legend: { position: "bottom" },
        },
      },
    ],
  };

  return (
    <div>
      <Chart options={options} series={series} type="pie" height={335} />
    </div>
  );
};

export default DailyAudit;
